module.exports = __webpack_public_path__ + "static/media/team-1.c465423a.avif";